import React from 'react'
import styles from "./SectionCollage.module.css"

const SectionCollage = () => {
  return (
    <section className={styles.sectionCollage}>
        <div className={styles.imagesContent}> 
            <div className={styles.divImg}>
                <img src="/images/habitacion.jpg" alt="Confort" />
                <div className={styles.overlayImg}>
                    <p className={styles.title}>Confort</p>
                </div>
            </div>
            <div className={styles.divImg}>
                <img src="/images/pescado_filete_2.jpg" alt="Gastronomia" />
                <div className={styles.overlayImg}>
                    <p className={styles.title}>Gastronomía Esmeraldeña</p>
                </div>
            </div>
            <div className={styles.divImg}>
                <img src="/images/hotel.jpg" alt="Piscina" />
                <div className={styles.overlayImg}>
                    <p className={styles.title}>Piscina con vista al mar</p>
                </div>
            </div>
        </div>
        <div className={styles.ContainerBtn}>
            <a href="https://wa.me/c/593980202185" className="primaryBtn">Habitaciones</a>
        </div>
    </section>
  )
}

export default SectionCollage